export enum KeyboardLayout {
  QWERTY = "QWERTY",
  QWERTZ = "QWERTZ",
}
